(function ($) {
	var $document = $(document);

	// Industry Picker
	$(function () {
		$document.on('change', '.ld-industry-selector-container select[name="ld-industry-selector"]', function () {
			var industry = $(this).val().replace(new RegExp(" ", 'g'), "-").toLowerCase();
			window.location.href = (window.ld.homeUrl + "/" + window.ld.membersPageSlug + "/industry/" + industry);
		});
	});

	// Sub options
	$(function () {
		$document.on('change', '.ld-industry-selector-container select[name="ld-industry-sub-selector"]', function () {
			var sub = ($(this).val() ? parseInt($(this).val()) : '');
			var urlParams = new URLSearchParams(window.location.search);

			urlParams.set('sb', sub);
			window.location.search = urlParams;
		});
	});
})(jQuery);
